<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/chat' }">客户沟通</el-breadcrumb-item>
      <el-breadcrumb-item>聊天记录</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 好友档案头 -->
    <el-card class="box-card" style="margin-top: 12px;">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">
          {{ (friend && (friend.conRemark || friend.nickname)) || '聊天记录' }}
          <span v-if="friend && friend.conRemark && friend.nickname" style="font-size:13px;color:#909399;">（{{ friend.nickname }}）</span>
        </span>
        <span style="float:right;">
          <span style="font-size:13px;color:#606266;margin-right:10px;">日期区间：</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 240px; margin-right: 10px;"
            @change="reload">
          </el-date-picker>
          <el-button size="small" icon="el-icon-back" @click="$router.push('/zhaoshang/chat')">返回列表</el-button>
        </span>
      </div>
      <el-descriptions v-if="friend" :column="4" size="small" border style="background:#fff;">
        <el-descriptions-item label="昵称">{{ friend.nickname || '（空）' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ friend.conRemark || '（空）' }}</el-descriptions-item>
        <el-descriptions-item label="添加时间">{{ friend.passTime ? formatTime(friend.passTime) : '未知' }}</el-descriptions-item>
        <el-descriptions-item label="类型/城市">
          {{ friend.type || '无' }} / {{ friend.city || '无' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 消息流 -->
    <el-card class="box-card" style="margin-top: 12px;">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">消息流<span style="font-size:12px;color:#909399;">（专员消息居右，客户消息居左）</span></span>
      </div>

      <div style="text-align:center;margin-bottom:10px;">
        <el-button v-if="hasMore" size="mini" :loading="loading" @click="loadEarlier">加载更早消息</el-button>
        <span v-else-if="messages.length" style="font-size:12px;color:#C0C4CC;">已到最早</span>
      </div>

      <div v-loading="loading" class="msg-stream">
        <template v-if="messages.length">
          <div v-for="m in messages" :key="m.msgKey">
            <!-- 系统事件：居中灰色 -->
            <div v-if="isSystem(m)" class="sys-event">{{ sysText(m) }}</div>
            <!-- 业务消息气泡 -->
            <div v-else class="msg-row" :class="{ mine: m.isSend }">
              <div class="bubble" :class="{ mine: m.isSend }">
                <!-- 撤回标注 -->
                <div v-if="m.recalled" class="recalled-tag">已撤回</div>
                <!-- 文本 -->
                <div v-if="m.msgType === 1" class="text">{{ m.content }}</div>
                <!-- 语音 -->
                <div v-else-if="m.msgType === 34" class="voice">
                  <div class="voice-head">
                    <i class="el-icon-microphone"></i>
                    语音 {{ voiceDuration(m) }}"
                  </div>
                  <div v-if="m.transcript" class="transcript-text">{{ m.transcript }}</div>
                  <div v-else-if="m.transcriptError" class="transcript-err">转写失败</div>
                  <div v-else class="transcript-pending">转写中…</div>
                </div>
                <!-- 通话 -->
                <div v-else-if="m.msgType === 50" class="call">
                  <div class="call-head">
                    <i class="el-icon-phone-outline"></i>
                    {{ callText(m) }}
                  </div>
                  <div v-if="m.transcript" class="transcript-text">{{ m.transcript }}</div>
                  <div v-else-if="m.transcriptError" class="transcript-err">转写失败</div>
                  <div v-else-if="callAccepted(m)" class="transcript-pending">转写中…</div>
                </div>
                <!-- 图片：OSS 直链懒加载+点击看大图，死链回退占位 -->
                <div v-else-if="m.msgType === 3" class="img-msg">
                  <el-image
                    v-if="m.content && m.content.startsWith('https://')"
                    :src="m.content"
                    :preview-src-list="[m.content]"
                    fit="cover"
                    lazy
                    class="chat-img">
                    <div slot="error" class="placeholder">
                      <i class="el-icon-picture-outline"></i>
                      {{ placeholderText(3) }}（已失效）
                    </div>
                    <div slot="placeholder" class="placeholder">
                      <i class="el-icon-picture-outline"></i>
                      {{ placeholderText(3) }}
                    </div>
                  </el-image>
                  <div v-else class="placeholder">
                    <i class="el-icon-picture-outline"></i>
                    {{ placeholderText(3) }}
                  </div>
                </div>
                <!-- 其余类型占位卡 -->
                <div v-else class="placeholder">
                  <i :class="placeholderIcon(m.msgType)"></i>
                  {{ placeholderText(m.msgType) }}
                </div>
              </div>
              <div class="msg-time">{{ formatTime(m.wechatTime) }}</div>
            </div>
          </div>
        </template>
        <el-empty v-else-if="!loading" description="该区间内暂无消息，可调整日期区间后重试"></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>
const TYPE_LABEL = {
  3: '图片',
  42: '名片',
  43: '视频',
  47: '表情',
  48: '位置',
  49: '链接/文件'
}

export default {
  name: 'ZhaoshangChatDetail',
  data () {
    return {
      loading: false,
      messages: [],
      hasMore: false,
      nextCursor: '',
      friend: null,
      dateRange: null
    }
  },
  computed: {
    wechatAccountId () {
      return this.$route.query.wechatAccountId || ''
    },
    friendId () {
      return this.$route.query.friendId || ''
    }
  },
  created () {
    if (!this.wechatAccountId || !this.friendId) {
      this.$message.error('缺少账号或好友参数')
      return
    }
    this.loadLatest()
  },
  watch: {
    // 列表页跳转到另一好友时组件不重建（同路由不同 query），须监听重载
    '$route.query.friendId' () {
      if (this.$route.query.wechatAccountId && this.$route.query.friendId) {
        this.dateRange = null
        this.loadLatest()
      }
    }
  },
  methods: {
    async loadLatest () {
      this.loading = true
      this.messages = []
      this.hasMore = false
      this.nextCursor = ''
      try {
        const { data: res } = await this.$http.get('zhaoshang/chat/messages', {
          params: {
            wechatAccountId: this.wechatAccountId,
            friendId: this.friendId,
            dateFrom: (this.dateRange && this.dateRange[0]) || '',
            dateTo: (this.dateRange && this.dateRange[1]) || '',
            pagesize: 50
          }
        })
        if (res.meta.status === 200) {
          this.messages = res.data.list || []
          this.hasMore = res.data.hasMore
          this.nextCursor = res.data.nextCursor
          this.friend = res.data.friend
        } else {
          this.$message.error(res.meta.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    async loadEarlier () {
      if (!this.nextCursor) return
      this.loading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/chat/messages', {
          params: {
            wechatAccountId: this.wechatAccountId,
            friendId: this.friendId,
            dateFrom: (this.dateRange && this.dateRange[0]) || '',
            dateTo: (this.dateRange && this.dateRange[1]) || '',
            cursor: this.nextCursor,
            direction: 'before',
            pagesize: 50
          }
        })
        if (res.meta.status === 200) {
          const older = res.data.list || []
          this.messages = older.concat(this.messages)
          this.hasMore = res.data.hasMore
          this.nextCursor = res.data.nextCursor
        } else {
          this.$message.error(res.meta.msg || '查询失败')
        }
      } catch (e) {
        this.$message.error('查询失败')
      } finally {
        this.loading = false
      }
    },
    reload () {
      this.loadLatest()
    },
    isSystem (m) {
      return m.msgType === 10000 || m.msgType === 10002
    },
    sysText (m) {
      if (m.recalled) return '消息已撤回'
      return m.content || '系统消息'
    },
    parseContent (m) {
      try {
        return JSON.parse(m.content)
      } catch (e) {
        return {}
      }
    },
    voiceDuration (m) {
      const c = this.parseContent(m)
      return Math.max(1, Math.round((c.durationMs || 0) / 1000))
    },
    callAccepted (m) {
      const c = this.parseContent(m)
      return c.action === 'accepted'
    },
    callText (m) {
      const c = this.parseContent(m)
      if (c.action === 'accepted') {
        const sec = c.duration || 0
        return `通话 ${Math.floor(sec / 60)}分${sec % 60}秒`
      }
      return c.content || '通话（未接通/已取消）'
    },
    placeholderText (t) {
      return `[${TYPE_LABEL[t] || '消息'}]`
    },
    placeholderIcon (t) {
      const map = { 3: 'el-icon-picture-outline', 42: 'el-icon-postcard', 43: 'el-icon-video-camera', 47: 'el-icon-sunny', 48: 'el-icon-location-outline', 49: 'el-icon-link' }
      return map[t] || 'el-icon-chat-line-square'
    },
    formatTime (ms) {
      if (!ms) return ''
      const d = new Date(ms)
      const p = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`
    }
  }
}
</script>

<style scoped>
.msg-stream { min-height: 300px; max-height: 65vh; overflow-y: auto; padding: 4px 8px; background: #F5F7FA; border-radius: 4px; }
.sys-event { text-align: center; color: #909399; font-size: 12px; margin: 10px 0; }
.msg-row { display: flex; flex-direction: column; align-items: flex-start; margin: 8px 0; }
.msg-row.mine { align-items: flex-end; }
.bubble { max-width: 72%; background: #fff; border-radius: 8px; padding: 8px 12px; box-shadow: 0 1px 2px rgba(0,0,0,.06); word-break: break-all; }
.bubble.mine { background: #D9ECFF; }
.msg-time { font-size: 11px; color: #C0C4CC; margin-top: 3px; padding: 0 4px; }
.recalled-tag { font-size: 11px; color: #F56C6C; margin-bottom: 4px; }
.text { font-size: 14px; line-height: 1.6; white-space: pre-wrap; }
.voice-head { font-size: 13px; color: #409EFF; margin-bottom: 4px; }
.call-head { font-size: 13px; color: #67C23A; margin-bottom: 4px; }
.img-msg .chat-img { width: 150px; height: 150px; border-radius: 6px; overflow: hidden; background: #F5F7FA; }
.img-msg .chat-img >>> .image-slot { display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; }
.placeholder { font-size: 13px; color: #909399; }
.transcript-text { font-size: 13px; color: #606266; line-height: 1.6; white-space: pre-wrap; margin-top: 2px; }
.transcript-err { font-size: 12px; color: #F56C6C; }
.transcript-pending { font-size: 12px; color: #C0C4CC; }
</style>
